// features/subdomainSlice.js
import { createSlice } from '@reduxjs/toolkit';

const getInitialSubdomain = () => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('subdomain') || null;
};

const subdomainSlice = createSlice({
  name: 'subdomain',
  initialState: {
    value: getInitialSubdomain(),
  },
  reducers: {
    setSubdomain: (state, action) => {
      state.value = action.payload;
      if (typeof window !== 'undefined') {
        localStorage.setItem('subdomain', action.payload ?? '');
      }
    },
  },
});

export const { setSubdomain } = subdomainSlice.actions;
export const subdomainSelector = (state) => state.subdomain.value;

export default subdomainSlice.reducer;
